/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Ignore_Timecodes_LabelInputs */



/**
* | output |
* | --- |
* | "Ignore Timecodes" |
*
* @param {Plain_Text_Import_Ignore_Timecodes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_ignore_timecodes_label = /** @type {((inputs?: Plain_Text_Import_Ignore_Timecodes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Ignore_Timecodes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ignorer les timecodes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcodes ignorieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ignora i codici temporali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Игнорировать временные метки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ignorar códigos de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("忽略时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードを無視")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड को अनदेखा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ignorar códigos de tempo")
	return /** @type {LocalizedString} */ ("Ignore Timecodes")
});